import { render } from "./HiFireDoc.vue?vue&type=template&id=030ae4f8&scoped=true"
import script from "./HiFireDoc.vue?vue&type=script&lang=js"
export * from "./HiFireDoc.vue?vue&type=script&lang=js"

import "./HiFireDoc.vue?vue&type=style&index=0&id=030ae4f8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030ae4f8"]])

export default __exports__